/**
 * This class can render text onto the screen
 */
export class Texter {
    onScreen: Phaser.Text;

    constructor (public game: Phaser.Game) {
    }

    render(text: string, x: number, y: number) {
        if(this.onScreen !== undefined) this.onScreen.destroy();
        var texterStyle = { font: "15px Roboto", fill: "#000", align: "left", width: 400 };
        this.onScreen = this.game.add.text(x, y, text, texterStyle);
    }
}


// WEBPACK FOOTER //
// ./src/texter.ts